module.exports = __webpack_public_path__ + "img/ysjf.7d67a0a4.png";